const PaymentController = function ($scope, Voucher, Cart, Discount) {

  $scope.Cart = Cart;
  $scope.Voucher = Voucher;
  $scope.Discount = Discount;

  $scope.preselectedPaymentVoucher = null;

  if ($scope.Cart.paymentMethod !== null && $scope.Cart.paymentMethod.identifier === 'debit') {
    $scope.showPaymentOptions = false;
  } else {
    $scope.showPaymentOptions = true;
  }

  if (cartConfig.paymentmethodid) {
    const cartPaymentMethod = $scope.$parent.paymentMethods.filter((paymentMethod) => paymentMethod.id === parseInt(cartConfig.paymentmethodid))[ 0 ];
    $scope.setPaymentMethod(cartPaymentMethod);
    $scope.showPaymentOptions = false;
  }

  $scope.abortVoucher = function () {
    $scope.setShowVoucherForm(false);
    Voucher.item = null;
    Cart.paymentMethod = null;
    Cart.paymentVoucher = null;
    $scope.preselectedPaymentVoucher = null;
  };
  $scope.setShowVoucherForm = function (value) {
    $scope.showVoucherForm = value;
  };

  $scope.redeemVoucher = function () {
    Voucher.redeem($scope).then(function (response) {
      if (!Voucher.redeemError) {
        $scope.preselectedPaymentVoucher = null;
      }
      return response;
    });
  };

  $scope.setPaymentMethod = function (item) {

    if (item.identifier === 'voucher') {
      $scope.setShowVoucherForm(true);
      Voucher.code = '';

      // to show the form if the voucher was removed directly after it was added
      $scope.paymentMethod = item;
      $scope.preselectedPaymentVoucher = item;
      Cart.paymentMethod = null;

    } else {
      $scope.preselectedPaymentVoucher = null;
      var showOptions = false;
      if ($scope.Cart.paymentMethod && (item.id == $scope.Cart.paymentMethod.id)) {
        showOptions = !$scope.showPaymentOptions;
      }
      $scope.setShowPaymentOptions(showOptions);

      $scope.paymentMethod = item;
      Cart.paymentMethod = item;

      return $scope.$parent.setPaymentMethod(item);
    }
  };
  $scope.setShowPaymentOptions = function (value) {
    $scope.showPaymentOptions = value;
  };

};

export default PaymentController;